<template>
  <div class="collab-opportunity-header" :class="{ active: isActive }">
    <div class="step-number">{{ stepNumber }}</div>
    <div>
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <IconEmbedded class="header-icon" :name="icon" />
  </div>
</template>

<script setup lang="ts">
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { IconName } from "@contracts/IconName";

defineProps<{
  isActive: boolean;
  title: string;
  description: string;
  icon: IconName;
  stepNumber: number;
}>();
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";
.collab-opportunity-header {
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-radius: 4px;

  &.active {
    .step-number {
      background-color: $dark-green;
      color: white;
    }
  }
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  min-width: 2rem;
  height: 2rem;
  width: 2rem;
  border-radius: 9999px;
  padding: 0px;
  background-color: white;
  margin-right: 1rem;
}

.title {
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 0.75rem;
}
.description {
  font-size: 1rem;
  font-weight: 400;
}
.header-icon {
  margin-left: 16px;
  width: 34px;
  height: 34px;
  margin-left: auto;
}
// tablet and smaller
@media (max-width: $tablet-max-width) {
  .step-number {
    display: none;
  }
  .collab-opportunity-header {
    align-items: center;
  }
  .title {
    margin: 0;
    font-size: 1.5rem !important;
  }
  .description {
    display: none;
  }
  .header-icon {
    display: none;
  }
}
</style>
